import React from 'react'
import currencyConverter from '@helpers/misc/currencyConverter'
import classNames from 'classnames'
import styles from './styles.module.scss'

type PriceComparisonProps = {
  price: string | number | null
  fullPrice: string | number | null
  classes?: string
  size?: string
  currency?: string
}

function PriceComparison({
  price = null,
  fullPrice = null,
  size = 'medium',
  currency = undefined,
  classes = ''
}: PriceComparisonProps) {
  const isReducedPrice = Number(fullPrice) > Number(price)
  const priceClasses = classNames(styles.PriceComparison__price, {
    [styles.PriceComparison__priceReduced]: isReducedPrice
  })
  return (
    <>
      {fullPrice != null && isReducedPrice ? (
        <p
          className={`${styles.PriceComparison__fullPrice} ${
            styles[size] || ''
          } ${classes}`}
        >
          {currencyConverter({ price: fullPrice, currency })}
        </p>
      ) : (
        ''
      )}
      {price != null && (
        <p
          data-price={price}
          className={`${priceClasses} ${styles[size] || ''} ${classes}`}
        >
          {currencyConverter({ price, currency })}
        </p>
      )}
    </>
  )
}

export default PriceComparison
